import { graphql } from "react-relay";

export const AddNotificationRuleMutation = graphql`
  mutation AddNotificationRuleMutation(
    $connections: [ID!]!
    $input: AddNotificationRuleInput!
  ) {
    addNotificationRule(input: $input) {
      notificationRule
        @appendNode(
          connections: $connections
          edgeTypeName: "NotificationRuleEdge"
        ) {
        description
        filterJSON
        groupBy
        id
        includeCostData
        name
        openGroupCount
        openResourceCount
        updateSchedule
        uuid
      }
      problems {
        message
      }
    }
  }
`;
